import React from 'react';
import styled from 'styled-components';
import { useLinkComponent } from '../../utils/component';
import { useTranslation } from '../../utils/translation';

const Affiliation = styled.div`
  border-radius: 6px;
  border: solid 1px transparent;
  font-style: italic;
  line-height: 26px;
  margin: var(--spacer-fluid) 0;
  padding: 0 var(--spacer-fluid);
`;

export const AffiliationInform = () => {
  const t = useTranslation();
  const LinkComponent = useLinkComponent();

  return (
    <Affiliation>
      {t('design.inform.affiliation.description')}&nbsp;
      <LinkComponent
        className="mod-primary"
        href="https://www.clubic.com/clubic/dossier-369336-a-propos-.html"
        rel={['nofollow']}
        openInNewWindow
      >
        {t('design.inform.affiliation.linkText')}
      </LinkComponent>
    </Affiliation>
  );
};
